import React from 'react'

import type { CampaignBannerHeaderContentBlock } from '@library/api-menu-experience'
import { CampaignBanner } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { useMenuExperienceCategoryNavigation } from '../menuExperienceNavigationContext'

type CampaignBannerContentBlockWrapperProps = {
  contentBlock: CampaignBannerHeaderContentBlock
}

const onAddClick = () => {}
const onBlockedAddAttempt = () => {}
const onRecipeClick = () => {}
const onRemoveClick = () => {}

const getRecipeCardState =
  (contentBlock: CampaignBannerHeaderContentBlock) => (recipeId: RecipeUUID) => {
    const recipe = contentBlock.items.find(
      (
        item,
      ): item is Extract<CampaignBannerHeaderContentBlock['items'][number], { type: 'recipe' }> =>
        item.type === 'recipe' && item.id === recipeId,
    )

    return {
      isInBasket: false,
      isOutOfStock: recipe ? !recipe.isAvailable : false,
    }
  }

export const CampaignBannerContentBlockWrapper = ({
  contentBlock,
}: CampaignBannerContentBlockWrapperProps) => {
  const { selectCategory } = useMenuExperienceCategoryNavigation()

  const onCtaClick = (targetCategory: { id: string; slug: string }) => {
    selectCategory(targetCategory, 'merch_banner', undefined, {
      merch_header_type: contentBlock.type,
    })
  }

  return (
    <CampaignBanner
      contentBlock={contentBlock}
      getRecipeCardState={getRecipeCardState(contentBlock)}
      canAddRecipes={true}
      reachedLimit={false}
      onAddClick={onAddClick}
      onBlockedAddAttempt={onBlockedAddAttempt}
      onCtaClick={onCtaClick}
      onRecipeClick={onRecipeClick}
      onRemoveClick={onRemoveClick}
    />
  )
}
